module.exports = __webpack_public_path__ + "img/match-5.f2b8b460.webp";